export default "__VITE_ASSET__CkZ6nUwh__"